var map = {
	"./chart_icon.svg": 693,
	"./chart_icon_selected.svg": 4257,
	"./chart_icon_selected_mobile.svg": 7893,
	"./chat_icon.svg": 5369,
	"./chat_icon_selected.svg": 4296,
	"./chat_icon_selected_mobile.svg": 6176,
	"./email_icon.svg": 1469,
	"./email_icon_selected.svg": 5468,
	"./email_icon_selected_mobile.svg": 72,
	"./event_icon.svg": 2416,
	"./event_icon_selected.svg": 9346,
	"./event_icon_selected_mobile.svg": 2564,
	"./help_icon.svg": 3423,
	"./help_icon_selected.svg": 6599,
	"./help_icon_selected1.svg": 6526,
	"./help_icon_selected_mobile.svg": 2142,
	"./home_icon.svg": 7314,
	"./home_icon_selected.svg": 4032,
	"./home_icon_selected_mobile.svg": 844,
	"./icon.png": 4329,
	"./logout_icon.svg": 4764,
	"./multi_user.svg": 4480,
	"./multi_user_selected.svg": 5201,
	"./multi_user_selected_mobile.svg": 4156,
	"./setting_icon.svg": 3826,
	"./setting_icon_selected.svg": 8078,
	"./setting_icon_selected_mobile.svg": 6228
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2166;